import React, { useEffect } from 'react';
import { Table } from 'tdesign-react';
import useTable from '@/hooks/useTable';
import { renderByteRate, renderDateTime, renderNum, renderNumRate } from '@/utils/common';
import ColTip from '@/components/Tip';

export default function Subscriptions({ data }) {
  const columns = [
    {
      colKey: 'subscriptionName',
      title: '订阅名',
      sorter: true,
      width: 180,
    },
    {
      colKey: 'type',
      sorter: true,
      title: '订阅类型',
    },
    {
      colKey: 'rateOut',
      title: '消费速率',
      sorter: true,
      cell: renderNumRate,
    },
    {
      colKey: 'bytesOut',
      title: '消费吞吐',
      sorter: true,
      cell: renderByteRate,
    },
    {
      colKey: 'onlineConsumers',
      title: '在线个数',
      sorter: true,
    },
    {
      colKey: 'msgDelayed',
      title: (
        <ColTip
          content={
            <>
              <strong>延迟消息</strong>
              <li>还未达到消费时间的消息条数。</li>
            </>
          }
        >
          延迟消息
        </ColTip>
      ),
      sorter: true,
      cell: renderNum,
      width: 140,
    },
    {
      colKey: 'backlog',
      sorter: true,
      title: '积压条数',
      cell: renderNum,
    },
    {
      colKey: 'lastAckedTime',
      title: '最后ACK时间',
      cell: renderDateTime,
      width: 180,
    },
  ];

  const { config, setData } = useTable({ columns });

  useEffect(() => {
    setData(data);
  }, [data, setData]);

  return <Table style={{ marginTop: 16 }} {...config} />;
}
